import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaContratosExpo25 from '../../../components/contratos/listar/expomacuco';


function ListaContratosExpo25Screen() {
    return (
        <Fragment>
            <Head titulo="Contratos Firmados para a Expo Macuco 2025" />
            <Header />
            <Container>
                <ListaContratosExpo25 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosExpo25Screen;